













































































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { Job, JobStatus } from '@/models/job.interface';
import { Action, Getter } from 'vuex-class';
import Modal from '@/components/common/Modal.vue';
import NoResult from '@/components/common/NoResult.vue';
import { ModalOptions } from '@/models/modal.interface';
import { PaginationInfo } from '@/models/util.interface';
import { User } from '@/models/user.interface';

@Component({ components: { Modal, NoResult } })
export default class JobTable extends Vue {
  @Action('openModalAction') public openModalAction!: (payload: ModalOptions) => void;
  @Action('selectJobAction') public selectJobAction!: (payload: Job) => void;
  @Action('addJobAction') public addJobAction!: (payload: Job) => void;
  @Action('removeJobAction') public removeJobAction!: (id: string) => void;
  @Action('changeJobPageAction') public changeJobPageAction!: (id: number) => void;
  @Getter public isModalValidated!: boolean;
  @Getter public modalPayload!: string;
  @Getter public jobPaginationInfo!: PaginationInfo;
  @Getter public jobsLoading!: boolean;
  @Getter public userConnected!: User;
  @Prop() private jobs!: Job[];

  private page: number;

  constructor() {
    super();
    this.page = 1;
  }

  public showModal(job: Job): void {
    this.openModalAction({
      title: 'Confirmation',
      message: `Êtes vous sûr de vouloir supprimer l'offre d'emploi ?`,
      payload: job._id,
    });
  }

  public goToDetail(job: Job): void {
    this.selectJobAction(job);
    this.$router.push(`/job/${job._id}`);
  }

  public goToEdit(job: Job): void {
    this.$router.push(`/job/${job._id}/edit`);
  }

  public onPaginate(page: number) {
    this.changeJobPageAction(page);
  }

  @Watch('isModalValidated')
  private onModalValidatedChanged(value: boolean, oldValue: boolean) {
    value && this.removeJob();
  }

  @Watch('jobPaginationInfo')
  private onPaginationChanged(value: PaginationInfo, oldValue: PaginationInfo) {
    this.page = value.page ? +value.page : 1;
  }

  @Emit()
  private async cloneJob(job: Job): Promise<Job> {
    await this.addJobAction({...job, _id: null as any, status: JobStatus.DRAFT});
    this.$notify({text: `Offre d'emploi dupliquée avec succès`, type: 'success'});
    return job;
  }

  @Emit()
  private async removeJob(): Promise<string> {
    await this.removeJobAction(this.modalPayload);
    return this.modalPayload;
  }
}
